import React, { useEffect } from "react";
import { staff, siteInfo } from "../data/mockData";
import { Phone, Mail, MapPin } from "lucide-react";
import { ContactInfo } from "../components/contact/ContactInfo";
import { ContactForm } from "../components/contact/ContactForm";

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/* Hero */}
      <section className="relative h-[50vh] min-h-[400px] flex items-center">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url(/images/img1875.jpeg)",
          }}
        >
          <div className="absolute inset-0 bg-[#1B2A4A]/75" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full">
          <span className="text-[#C9A96E] text-sm font-medium tracking-[0.2em] uppercase">
            Get In Touch
          </span>
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mt-3">
            Contact Us
          </h1>
          <p className="text-white/70 text-lg mt-4 max-w-xl">
            We'd love to hear from you. Reach out for tee times, event
            planning, or any questions about Willow Ridge.
          </p>
        </div>
      </section>

      {/* Contact Info + Form */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <ContactInfo />
            <ContactForm />
          </div>
        </div>
      </section>

      {/* Staff */}
      <section className="py-24 bg-[#f8f7f4]">
        <div className="max-w-6xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <span className="text-[#C9A96E] text-sm font-medium tracking-[0.2em] uppercase">
              Our Team
            </span>
            <h2 className="text-4xl font-serif font-bold text-[#1B2A4A] mt-3">
              Professional Staff
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {staff.map((member) => (
              <div
                key={member.name}
                className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-500 flex flex-col sm:flex-row"
              >
                <div className="sm:w-48 h-56 sm:h-auto shrink-0 overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover object-[60%_15%]"
                  />
                </div>
                <div className="p-6 flex-1">
                  <h3 className="text-xl font-serif font-bold text-[#1B2A4A]">
                    {member.name}
                  </h3>
                  <div className="text-[#C9A96E] text-sm font-medium">
                    {member.title}
                  </div>
                  <div className="text-gray-400 text-xs mb-3">
                    {member.department}
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">
                    {member.description}
                  </p>
                  <div className="space-y-2">
                    {member.email && (
                      <a
                        href={`mailto:${member.email}`}
                        className="flex items-center gap-2 text-sm text-gray-500 hover:text-[#C9A96E] transition-colors"
                      >
                        <Mail size={14} />
                        {member.email}
                      </a>
                    )}
                    {member.phone && (
                      <a
                        href={`tel:${member.phone}`}
                        className="flex items-center gap-2 text-sm text-gray-500 hover:text-[#C9A96E] transition-colors"
                      >
                        <Phone size={14} />
                        {member.phoneDisplay || member.phone}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Directions */}
      <section className="py-20 bg-[#1B2A4A]">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <MapPin size={32} className="text-[#C9A96E] mx-auto mb-4" />
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4">
            Getting Here
          </h2>
          <p className="text-white/60 mb-4">
            {siteInfo.address}, {siteInfo.city} {siteInfo.postal}
          </p>
          <p className="text-white/40 text-sm mb-8">
            Located just south of Blenheim on Chatham Street South. Ample
            free parking available for all guests.
          </p>
          <a
            href="https://www.google.com/maps/dir//Willow+Ridge+Golf+and+Country+Club"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#C9A96E] text-[#1B2A4A] font-semibold rounded-md hover:bg-[#d4b97e] transition-colors duration-300"
          >
            Get Directions
          </a>
        </div>
      </section>
    </div>
  );
};

export default Contact;
